import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import cx from 'classnames';
import { filter, find, map, noop, sortBy } from 'lodash';

import Icons from '../icons';
import ThumbNail from '../thumbNail/ThumbNail';

import { ICONS } from '../../constants/icons.constants';

import PopUp from '../popUp';
import { BASE_URL } from '../../axios';
import { scheduleActions } from '../../actions';
import SchedulesStore from '../../zustand/Schedule.store';
import userStore from '../../zustand/user.store';
import imageStore from '../../zustand/image.store';
import { downloadPlaylistImage } from '../../helpers/generel.helpers';

import styles from './scheduleListitem.module.scss';

const MAP_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const PlaylistSong = ({
  playlistId,
  songName,
  scheduleName,
  totalHours,
  days,
  liked,
  slotId,
  dropdownContainer,
  imageUrl,
  color,
  slots,
  scheduleId,
}) => {
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));
  const sortedDays = sortBy(days);

  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const { schedules, addORUpdateSchedule } = SchedulesStore(
    (state) => ({
      schedules: state.schedules,
      addORUpdateSchedule: state.addORUpdateSchedule,
    })
  );

  const { addImage } = imageStore((state) => ({
    addImage: state.addImage,
  }));

  const handleDeleteSchedule = async () => {
    setIsLoading(true);

    const updatedSchduleSlots = filter(slots, (item) => {
      return item.id !== slotId;
    });

    const response = await scheduleActions.updateSchedule(
      scheduleId,
      {
        playlist_id: playlistId,
        slots: updatedSchduleSlots,
      },
      userOffline
    );

    if (response) {
      const scheduleToUpdate = find(schedules, (item) => {
        return item.playlist_id === playlistId;
      });
      scheduleToUpdate.slots = updatedSchduleSlots;

      addORUpdateSchedule(scheduleToUpdate);
    }
    setIsDeleteModalVisible(false);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      const isSuccess = await downloadPlaylistImage(imageUrl);
      if (isSuccess) {
        addImage(imageUrl);
      }
    })();
  }, [addImage, imageUrl]);

  return (
    <div className={cx(styles.container, dropdownContainer)}>
      <div className={styles.img}>
        <ThumbNail
          name={songName || scheduleName}
          className={styles.imgThumb}
          hasImage={imageUrl}
          imgSrc={`${BASE_URL}/media/${imageUrl}`}
          color={color}
        />
      </div>

      <div className={cx(styles.extraInfo, styles.scheduleText)}>
        <p className={styles.text1}>{scheduleName}</p>
        <div className={styles.textBox}>
          <p className={styles.text2}>{totalHours + ' ' + 'Hr'}</p>
          <p className={styles.text2}>
            {map(sortedDays, (item) => MAP_DAYS[item] + ',  ')}
          </p>
        </div>
      </div>

      <div className={styles.box}>
        <div
          className={cx(styles.icon, { [styles.like]: liked })}
          onClick={() => setIsDeleteModalVisible(true)}>
          <Icons type={ICONS.DELETE} />
        </div>
      </div>
      <PopUp
        isOpen={isDeleteModalVisible}
        setIsOpen={setIsDeleteModalVisible}
        title='Are you sure, 
      you want to delete this schedule ?'
        iconType={ICONS.RED_DELETE}
        btnPlaceholder='Delete'
        onSuccess={handleDeleteSchedule}
        onCancle={() => setIsDeleteModalVisible(false)}
        id={playlistId}
        isLoading={isLoading}
      />
    </div>
  );
};

PlaylistSong.propTypes = {
  normalView: propTypes.bool,
  removeView: propTypes.bool,
  dropdownView: propTypes.bool,
  scheduleListView: propTypes.bool,
  songName: propTypes.string,
  artistName: propTypes.string,
  scheduleName: propTypes.string,
  totalHours: propTypes.string,
  days: propTypes.array,
  id: propTypes.string,
  removeSong: propTypes.func,
  playListView: propTypes.bool,
  setSelectedPlaylist: propTypes.func,
  dropdownDaysView: propTypes.bool,
  setIsStateChanged: propTypes.func,
};

PlaylistSong.defaultProps = {
  dropdownDaysView: false,
  normalView: false,
  setSelectedPlaylist: noop,
  removeView: false,
  dropdownView: false,
  playListView: false,
  scheduleListView: false,
  songName: '',
  artistName: '',
  scheduleName: '',
  totalHours: '',
  days: [],
  id: '',
  removeSong: noop,
  setIsStateChanged: noop,
};

export default memo(PlaylistSong);
